import React from 'react';
import { Button } from './ui/button';
import { Cloud, Shield, Award, ArrowRight } from 'lucide-react';

export default function WhyUsSection({ onCTAClick }) {

  return (
    <section id="expertise" className="py-20 px-4">
      <div className="container mx-auto max-w-6xl">
        {/* Main content card */}
        <div className="glass rounded-2xl p-8 md:p-12 relative overflow-hidden">
          {/* Background pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0 bg-gradient-to-br from-primary to-secondary" />
          </div>
          
          <div className="relative grid md:grid-cols-2 gap-12 items-center">
            {/* Left content */}
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold mb-6">
                Pourquoi
                <span className="text-gradient-purple"> Nous ?</span>
              </h2>
              
              <p className="text-lg text-muted-foreground leading-relaxed mb-8">
                Expertise Cloud Azure & Identité. Nous maîtrisons la complexité des infrastructures 
                hybrides et les contraintes de sécurité critiques.
              </p>

              {/* Features list */}
              <div className="space-y-6 mb-8">
                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Cloud className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Expertise Cloud Azure</h3>
                    <p className="text-sm text-muted-foreground">
                      Maîtrise complète de l'écosystème Azure et des services d'identité Auth0
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center">
                    <Shield className="w-6 h-6 text-secondary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Sécurité Critiques</h3>
                    <p className="text-sm text-muted-foreground">
                      Gestion des contraintes de sécurité les plus exigeantes avec certifications
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                    <Award className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">Infrastructures Hybrides</h3>
                    <p className="text-sm text-muted-foreground">
                      Expérience prouvée dans la migration d'environnements complexes On-Prem vers le Cloud
                    </p>
                  </div>
                </div>
              </div>

              <Button 
                size="lg"
                onClick={onCTAClick}
                className="bg-primary hover:bg-primary/90 text-primary-foreground glow-purple group"
              >
                Discuter de votre projet
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            {/* Right content - Stats */}
            <div className="space-y-6">
              <div className="glass rounded-xl p-6 border border-primary/20">
                <div className="text-4xl font-bold text-gradient-purple mb-2">10+</div>
                <div className="text-foreground font-semibold mb-1">Années d'expérience</div>
                <div className="text-sm text-muted-foreground">En migration d'identité et cloud</div>
              </div>

              <div className="glass rounded-xl p-6 border border-secondary/20">
                <div className="text-4xl font-bold text-gradient-blue mb-2">500K+</div>
                <div className="text-foreground font-semibold mb-1">Utilisateurs migrés</div>
                <div className="text-sm text-muted-foreground">Sans interruption de service</div>
              </div>

              <div className="glass rounded-xl p-6 border border-primary/20">
                <div className="text-4xl font-bold text-gradient-purple mb-2">99.9%</div>
                <div className="text-foreground font-semibold mb-1">Taux de réussite</div>
                <div className="text-sm text-muted-foreground">Sur toutes nos migrations</div>
              </div>
            </div>
          </div>
        </div>

        {/* Trust badges */}
        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground mb-6">Certifié et approuvé par</p>
          <div className="flex flex-wrap items-center justify-center gap-8 opacity-50">
            <div className="flex items-center gap-2">
              <Shield className="w-6 h-6" />
              <span className="font-semibold">Microsoft Azure</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-6 h-6" />
              <span className="font-semibold">Auth0 Partner</span>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-6 h-6" />
              <span className="font-semibold">ISO 27001</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
